import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import { setActiveItem, toggleEditPanel, updateEditableIframe } from '../../../containers/Editor/actions';
import EditPanel from '../../../containers/Editor/EditPanel';
import IframePanel from '../../../containers/Editor/EditPanel/IframePanel';
import VisibilityToggle from '../../../containers/Editor/VisibilityToggle';
import { EditableType, IGNORE_PAGE_CLICK_CLASSNAME } from '../../../containers/Editor/constants';
import { getBorderWidth } from '../../../containers/Editor/utils/helpers';
import { StyledIframeEditor, Border } from './styles';

interface IframeEditorProps {
	page: number;
	id: string;
	isActive: boolean;
	src: string;
	pageScale: number;
	isEditPanelDisplayed: boolean;
	isVisible: boolean;
	parentContainer: HTMLElement;
	dispatch: Dispatch<StoreState>;
}

const IframeEditor = ({
	page,
	id,
	src,
	isActive,
	isVisible,
	pageScale,
	isEditPanelDisplayed,
	parentContainer,
	dispatch,
}: IframeEditorProps) => {
	const handleClick = () => {
		if (!isActive) {
			dispatch(setActiveItem(id, page, null));

			if (!isEditPanelDisplayed) {
				dispatch(toggleEditPanel());
			}
		}
	};

	const handleVisibilityToggle = () => {
		dispatch(updateEditableIframe(page, id, {
			isVisible: !isVisible,
		}));
	};

	const renderEditPanel = () => (
		isActive && isEditPanelDisplayed && (
			<EditPanel
				defaultType={EditableType.iframe}
				panels={{
					[EditableType.iframe]: <IframePanel page={page} />,
				}}
			/>
		)
	);

	React.useEffect(() => {
		parentContainer.style.overflow = 'visible';
	}, []);

	return (
		<>
			<StyledIframeEditor
				className={IGNORE_PAGE_CLICK_CLASSNAME}
				onClick={handleClick}
				onTouchEnd={handleClick}
			>
				<iframe
					src={src}
					hidden={!isVisible}
				/>
				{(isActive || !isVisible) &&
					<Border
						isActive={isActive}
						borderWidth={getBorderWidth(pageScale)}
					/>
				}
			</StyledIframeEditor>
			<VisibilityToggle
				isVisible={isVisible}
				isParentActive={isActive}
				pageScale={pageScale}
				onToggle={handleVisibilityToggle}
			/>
			{renderEditPanel()}
		</>
	);
};

export default IframeEditor;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/IframeEditor/index.tsx